import {
    SellerProfileData,
} from "./SellerInfoTypes";

export const sellerProfiles: Record<
    string,
    SellerProfileData
> = {
    "salar-retail": {
        slug:
            "salar-retail",
        displayName:
            "Salar Retail",
        legalName:
            "Salar Retail Ventures Private Limited",
        initials:
            "SR",
        verified:
            true,
        status:
            "Trusted Marketplace Seller",
        about:
            "Salar Retail is a marketplace seller focused on authentic merchandise, dependable fulfilment and clear post-purchase support. Orders are handled through Salar's protected commerce experience, with seller communication linked to the relevant order for better privacy and resolution tracking.",
        sellerSince:
            "January 2026",
        shipsFrom:
            "Hyderabad, Telangana",
        fulfilment:
            "Salar Assured eligible",
        positiveFeedback:
            97,
        totalRatings:
            12846,
        ordersCompleted:
            "86K+",
        onTimeDispatch:
            "99.2%",
        cancellationRate:
            "0.6%",
        responseTime:
            "Under 4 hours",
        supportChannel:
            "Salar Secure Messaging",
        supportHours:
            "Mon–Sat · 9:00 AM–7:00 PM IST",
        supportPhone:
            "Available after order verification",
        supportEmail:
            "Available through Salar Help Centre",
        businessAddress:
            "Financial District, Nanakramguda, Hyderabad, Telangana 500032, India",
        returnSupport:
            "Eligible returns are routed to the seller's registered return facility after approval.",
        invoiceSupport:
            "GST invoice available on eligible orders.",
        taxStatus:
            "Business and tax registration verified by Salar",
        brandStoreSlug:
            "salar",
        businessInfo: [
            {
                label:
                    "Seller display name",
                value:
                    "Salar Retail",
            },
            {
                label:
                    "Legal business name",
                value:
                    "Salar Retail Ventures Private Limited",
            },
            {
                label:
                    "Business type",
                value:
                    "Private Limited Company",
            },
            {
                label:
                    "Registered business address",
                value:
                    "Financial District, Nanakramguda, Hyderabad, Telangana 500032, India",
            },
            {
                label:
                    "Tax verification",
                value:
                    "Verified marketplace business registration",
            },
            {
                label:
                    "Invoice support",
                value:
                    "GST invoice available where applicable",
            },
        ],
        feedbackSummary: {
            "30-days": {
                positive:
                    98,
                neutral:
                    1,
                negative:
                    1,
                total:
                    456,
            },
            "90-days": {
                positive:
                    98,
                neutral:
                    1,
                negative:
                    1,
                total:
                    1492,
            },
            "12-months": {
                positive:
                    97,
                neutral:
                    2,
                negative:
                    1,
                total:
                    9874,
            },
            lifetime: {
                positive:
                    97,
                neutral:
                    2,
                negative:
                    1,
                total:
                    12846,
            },
        },
        feedback: [
            {
                id:
                    "feedback-1",
                buyer:
                    "A***h",
                rating:
                    5,
                tone:
                    "positive",
                title:
                    "Delivered before expected date",
                comment:
                    "The package arrived safely, the product matched the listing and delivery updates were clear throughout the order.",
                date:
                    "28 Aug 2026",
                orderType:
                    "Fashion order",
            },
            {
                id:
                    "feedback-2",
                buyer:
                    "S***a",
                rating:
                    5,
                tone:
                    "positive",
                title:
                    "Good packaging and genuine item",
                comment:
                    "Everything was packed neatly and the item was exactly as described. Invoice was included as expected.",
                date:
                    "26 Aug 2026",
                orderType:
                    "Marketplace order",
            },
            {
                id:
                    "feedback-3",
                buyer:
                    "R***n",
                rating:
                    4,
                tone:
                    "positive",
                title:
                    "Smooth overall experience",
                comment:
                    "Dispatch was quick and tracking worked well. The product reached in good condition.",
                date:
                    "24 Aug 2026",
                orderType:
                    "Fashion order",
            },
            {
                id:
                    "feedback-4",
                buyer:
                    "M***i",
                rating:
                    3,
                tone:
                    "neutral",
                title:
                    "Delivery was slightly delayed",
                comment:
                    "The item itself was good, but the shipment arrived one day later than the initial estimate.",
                date:
                    "20 Aug 2026",
                orderType:
                    "Marketplace order",
                sellerResponse:
                    "We are sorry for the delay. The shipment was affected by a regional carrier hand-off and the route has been reviewed with our fulfilment team.",
            },
            {
                id:
                    "feedback-5",
                buyer:
                    "K***r",
                rating:
                    5,
                tone:
                    "positive",
                title:
                    "Quick replacement support",
                comment:
                    "I received help quickly after reporting a size issue. The replacement steps were easy to understand.",
                date:
                    "18 Aug 2026",
                orderType:
                    "Fashion order",
            },
            {
                id:
                    "feedback-6",
                buyer:
                    "V***h",
                rating:
                    2,
                tone:
                    "negative",
                title:
                    "Outer package was damaged",
                comment:
                    "The product was usable, but the outer shipping box reached me in poor condition.",
                date:
                    "09 Aug 2026",
                orderType:
                    "Marketplace order",
                sellerResponse:
                    "Thank you for the feedback. We have escalated the packaging issue and updated handling instructions for this product type.",
            },
        ],
        policies: [
            {
                id:
                    "shipping",
                title:
                    "Shipping & fulfilment",
                summary:
                    "How seller dispatch, tracking and fulfilment are handled.",
                details: [
                    "Eligible products may display Salar Assured fulfilment when marketplace service requirements are met.",
                    "Estimated delivery dates are shown before checkout and may vary by destination, inventory location and carrier capacity.",
                    "Tracking information becomes available in the order experience after dispatch.",
                    "Delayed or undeliverable shipments follow Salar's order-protection and resolution process.",
                ],
            },
            {
                id:
                    "returns",
                title:
                    "Returns & replacements",
                summary:
                    "Return eligibility depends on product category, condition and order policy.",
                details: [
                    "The applicable return window is displayed on the product detail page and inside the customer's order.",
                    "Products must meet the return-condition requirements for the selected reason.",
                    "Eligible size, colour or fulfilment issues may support replacement when inventory is available.",
                    "Some categories may have restricted or non-returnable conditions.",
                ],
            },
            {
                id:
                    "refunds",
                title:
                    "Refunds",
                summary:
                    "How approved refunds are processed.",
                details: [
                    "Approved refunds are processed through the original payment or marketplace-supported refund method.",
                    "Timing can depend on return inspection, payment method and banking processing.",
                    "Eligible pre-dispatch cancellations begin refund processing after cancellation is confirmed.",
                ],
            },
            {
                id:
                    "authenticity",
                title:
                    "Authenticity & listing accuracy",
                summary:
                    "Seller responsibility for supplying the product represented on the listing.",
                details: [
                    "Products must match the represented brand, model, variant and condition.",
                    "Applicable manufacturer or brand warranty information is displayed on the product page.",
                    "Customers can report suspected listing or authenticity issues through Salar support.",
                ],
            },
            {
                id:
                    "communication",
                title:
                    "Buyer-seller communication",
                summary:
                    "How customers can contact the seller safely.",
                details: [
                    "Order-specific communication should use Salar Secure Messaging.",
                    "Personal phone numbers and private email addresses are not displayed publicly.",
                    "Messages about returns, delivery or product issues should be linked to the relevant order.",
                ],
            },
        ],
        products: [
            {
                id: 3001,
                sourceId: 1,
                title:
                    "Premium Solid Casual Shirt",
                description:
                    "Pure cotton regular-fit shirt with a clean finish and easy everyday styling.",
                image:
                    "/assets/images/products/men-fas/men-1.png",
                price: 1549,
                mrp: 2899,
                rating: 4.6,
                reviews: "18.4K",
                badge:
                    "SALAR CHOICE",
                category:
                    "Men's Shirts",
            },
            {
                id: 3002,
                sourceId: 2,
                title:
                    "Minimal Printed Shirt",
                description:
                    "Breathable printed shirt with a modern silhouette and soft-touch fabric.",
                image:
                    "/assets/images/products/men-fas/men-2.png",
                price: 1299,
                mrp: 1999,
                rating: 4.4,
                reviews: "12.8K",
                badge:
                    "TRENDING",
                category:
                    "Men's Shirts",
            },
            {
                id: 3003,
                sourceId: 3,
                title:
                    "Checked Everyday Shirt",
                description:
                    "Relaxed cotton checks designed for dependable daily comfort.",
                image:
                    "/assets/images/products/men-fas/men-3.png",
                price: 1449,
                mrp: 2499,
                rating: 4.7,
                reviews: "45.5K",
                badge:
                    "BEST SELLER",
                category:
                    "Men's Shirts",
            },
            {
                id: 3004,
                sourceId: 4,
                title:
                    "Resort Printed Shirt",
                description:
                    "Lightweight resort styling with statement print and relaxed drape.",
                image:
                    "/assets/images/products/men-fas/men-4.png",
                price: 1699,
                mrp: 2799,
                rating: 4.5,
                reviews: "22.1K",
                badge:
                    "PREMIUM EDIT",
                category:
                    "Men's Shirts",
            },
            {
                id: 3005,
                sourceId: 5,
                title:
                    "Textured Linen Shirt",
                description:
                    "Breathable linen blend with refined texture and premium finishing.",
                image:
                    "/assets/images/products/men-fas/men-5.png",
                price: 1849,
                mrp: 3199,
                rating: 4.6,
                reviews: "16.9K",
                badge:
                    "LIMITED EDITION",
                category:
                    "Men's Shirts",
            },
            {
                id: 3006,
                sourceId: 6,
                title:
                    "Premium Mandarin Shirt",
                description:
                    "Soft premium fabric and a clean mandarin collar for smart-casual looks.",
                image:
                    "/assets/images/products/men-fas/men-6.png",
                price: 1749,
                mrp: 2999,
                rating: 4.8,
                reviews: "31.2K",
                badge:
                    "SALAR EXCLUSIVE",
                category:
                    "Men's Shirts",
            },
        ],
    },
};

export const getSellerProfile = (
    slug: string
) =>
    sellerProfiles[
    slug
    ] ??
    sellerProfiles[
    "salar-retail"
    ];
